import { render, staticRenderFns } from "./DataElementTargets.vue?vue&type=template&id=83dd61f6"
import script from "./DataElementTargets.vue?vue&type=script&lang=js"
export * from "./DataElementTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports